module.exports = __webpack_public_path__ + "img/resource-wx-active.092cb8f3.png";